import Model, { attr, belongsTo, hasMany, type HasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import { type AvailableLocales } from 'invite-sign/utils/date-fns-i18n';

import type Flow from './flow';
import type Location from './location';

export type LanguageOption = {
  displayName: string;
  languageCode: AvailableLocales;
  regionCode: string | null;
};

export default class IpadConfig extends Model {
  declare [Type]: 'ipad-config';

  @belongsTo('location', { async: false, inverse: null }) declare location: Location;
  @hasMany('flow', { async: false, inverse: 'ipadConfig' }) declare flows: HasMany<Flow>;

  @attr('string') declare buttonColor: string;
  @attr('string', { defaultValue: '#ffffff' }) declare buttonTextColor: string;

  @attr('number') declare companyId: number;
  @attr('string') declare companyLogoUrl: string;
  @attr('string') declare companyName: string;

  @attr('boolean') declare beenHereBeforeEnabled: boolean;
  @attr('string') declare defaultLanguageCode: AvailableLocales;
  @attr('boolean') declare multipleLanguageEnabled: boolean;
  @attr('array') declare multipleLanguageOptions: LanguageOption[];

  @attr('boolean') declare welcomeBackgroundColorEnabled: boolean;
  @attr('string') declare welcomeBackgroundColor: string;
  @attr('string') declare welcomeImageUrl: string | null;

  get availableFlows(): Flow[] {
    return this.flows.filter((flow) => flow.enabled);
  }

  get languagesEnabled(): boolean {
    return this.multipleLanguageEnabled && this.multipleLanguageOptions.length > 0;
  }
}
